// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    session_timeout: 7200,
    //api_url: 'https://ggsjjbrprc.execute-api.ap-southeast-1.amazonaws.com/dev',
    api_url: 'https://dev.abopool.amway.co.th/gateway/bo-web',
    client_id: '',
    grantType: '',
    clientSecret: '',
    //msal config
    msal_client_id: '5d9ac847-b818-47a0-bab3-7699c5fa9cc4',
    msal_authority: 'https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698',
    msal_redirect_uri: 'https://dev.abopool.amway.co.th/login/callback',
    msal_scope: ['User.Read', 'profile', 'openid', 'email'],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
